import React from 'react'
import PropTypes from 'prop-types'

/* doc
---
title: Image
name: Image
category: React - Bulma
---

A `Picture` component for showing images. This is a wrapper for Bulma's `.image` element.

See [Bulma Documentation](http://bulma.io/documentation/elements/image/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| src             | Image src                                     | string         |                           | yes           |
| srcset          | Image srcset                                  | string         |                           | no            |
| ratio           | Image ratio: "2x1", "square", etc.            | string         | "square"                  | no            |
| isLazy          | Image will be loaded lazily.                  | boolean        | false                     | no            |

```html_example
  <Picture src="/image.jpeg" alt="Needs more jpeg." isLazy />
```
*/
function Picture(props) {
  const {
    src, srcset, className, isLazy, ratio, ...rest
  } = props

  const classes = [
    'image',
    className || '',
    isLazy ? 'is-lazy' : '',
    ratio ? `is-${ratio}` : '',
  ]

  return (
    <figure className={classes.join(' ')}>
      <img
        src={!isLazy ? src : null}
        srcSet={!isLazy ? srcset : null}
        data-original={!isLazy ? src : null}
        data-original-set={!isLazy ? srcset : null}
        {...rest}
      />
    </figure>
  )
}

Picture.defaultProps = {
  isLazy: false,
}

Picture.propTypes = {
  // Image src.
  src: PropTypes.string.isRequired,
  // Image srcset.
  srcset: PropTypes.string,
  // Ratio of image: "2x1", "square", etc.
  ratio: PropTypes.string,
  // If image will be loaded lazily.
  isLazy: PropTypes.bool,
}

export default Picture
